export enum NotificationTemplateTransport {
  EMAIL = 'EMAIL',
  WS = 'WS',
}

export enum NotificationTemplateEventName {
  WALLET_REQUEST_FAILED = 'WALLET_REQUEST_FAILED',
  WALLET_REQUEST_CREATED = 'WALLET_REQUEST_CREATED',
  WALLET_CREATED = 'WALLET_CREATED',
  APPLICANT_REVIEWED = 'APPLICANT_REVIEWED',
  BANK_ACCOUNT_CREATED = 'BANK_ACCOUNT_CREATED',
  BANK_ACCOUNT_STATUS_CHANGE = 'BANK_ACCOUNT_STATUS_CHANGE',
  PROFILE_CREATED = 'PROFILE_CREATED',
  PROFILE_STATUS_CHANGE = 'PROFILE_STATUS_CHANGE',
  TRANSACTION_CREATED = 'TRANSACTION_CREATED',
  TRANSACTION_CHANGED = 'TRANSACTION_CHANGED',
  TRANSACTION_FAILED = 'TRANSACTION_FAILED',
  TRANSACTION_FINISHED = 'TRANSACTION_FINISHED',
  EXCHANGE_ORDER_CHANGED = 'EXCHANGE_ORDER_CHANGED',
}
